import React, { useState } from 'react';
import Link from 'next/link';
import { navData } from '@/utils/navData';
import SvgChevron from '@/assets/svg/icon-chevron.svg';

const getDefaultNavigatorState = () => {
  return {
    ourStory: false,
    ourStandards: false,
    ourHomes: false,
    ourPartners: false,
    about: false,
  };
};

interface Props {
  handleCloseNavigator: () => void;
}

const MobileHeader = ({ handleCloseNavigator }: Props) => {
  const [sectionState, setSectionState] = useState(getDefaultNavigatorState());

  const resetNavigatorState = () => {
    setSectionState(getDefaultNavigatorState());
  };

  const composeMenuSection = ({ sectionKey, nav }) => {
    return (
      <div>
        <h5
          onClick={() =>
            setSectionState({
              ...sectionState,
              [sectionKey]: !sectionState[sectionKey],
            })
          }
          className="mb-[25px] flex justify-between border-b border-b-white px-0 py-2.5 font-source-sans text-[24px] font-bold text-white"
        >
          {nav.title || 'Untitled'}
          <SvgChevron
            className={`${sectionState[sectionKey] ? 'rotate-180' : 'rotate-0'} mt-[7px] *:fill-white`}
          />
        </h5>
        <ul
          className={`${sectionState[sectionKey] ? 'block' : 'hidden'} mx-0 mb-5 mt-[-20px] list-none list-image-none`}
        >
          {nav.items?.map(
            (item, index) =>
              item.isHeader && (
                <li
                  key={index}
                  className="pb-[7px] pt-[5px] last-of-type:mb-2.5"
                >
                  <Link
                    href={item.url}
                    onClick={() => {
                      resetNavigatorState();
                      handleCloseNavigator();
                    }}
                    target={item.openNewWindow ? '_blank' : '_self'}
                    rel={item.openNewWindow ? 'noopener noreferrer' : ''}
                    className="text-[22px] font-normal leading-normal text-grey-4 no-underline hover:text-white hover:transition-[color_400ms_ease]"
                  >
                    {item.title}
                  </Link>
                </li>
              )
          )}
        </ul>
      </div>
    );
  };

  return (
    <div className="z-[198] smDesktop:hidden">
      <div className="mx-auto my-0 max-h-[600px] w-[90%] overflow-y-scroll">
        <div className="grid grid-cols-[1fr] gap-[5px]">
          {composeMenuSection({
            sectionKey: 'ourStory',
            nav: navData.ourStory,
          })}

          {composeMenuSection({
            sectionKey: 'ourStandards',
            nav: navData.ourStandards,
          })}

          {composeMenuSection({
            sectionKey: 'ourHomes',
            nav: navData.ourHomes,
          })}

          {composeMenuSection({
            sectionKey: 'ourPartners',
            nav: navData.ourBrandPartners,
          })}

          {composeMenuSection({
            sectionKey: 'about',
            nav: navData.about,
          })}
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;
